import * as React from "react"
import { CarouselSeeker } from "@ui-seeker/core"

import { distributionCarouselMove } from "Pages/SkuDetails/@signals"

export default function SkuDetailsDistributionCarousel({ children, ...props }) {

	return <CarouselSeeker 
        responsive={{ desktop: { items: 2 } }}
        centerMode
        afterChange={() => distributionCarouselMove.value = false}
        beforeChange={() => distributionCarouselMove.value = true}
        {...props}
    >
        { children }
    </CarouselSeeker>
}